// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import endpoints from '../../../endpoint'
// import {
//     TableContainer,
//     Paper,
//     Table,
//     TableHead,
//     TableRow,
//     TableCell,
//     TableBody
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// const AllPartner = () => {
//     const [data, setData] = useState()

//     const navigate = useNavigate();
//     useEffect(() => {

//         const fetchPartnerRequest = async () => {
//             try {
//                 const response = await axios.get(endpoints.serverBaseUrl + "api/partner", {
//                     withCredentials: true,
//                     headers: {
//                         Authorization: `Bearer ${sessionStorage.getItem("token")}`
//                     }

//                 });

//                 if (response.data.success) {
//                     console.log(response.data.data)
//                     setData(response.data.data)
//                 }

//             } catch (error) {
//                 console.log(error.message)
//             }
//         }

//         fetchPartnerRequest();
//     }, [])
//     console.log(data)

//     const handleNavigate = (partnerId) => {
//         navigate("/admin-dashboard/partner/info/" + partnerId)
//     }

//     return (
//         <TableContainer component={Paper}>
//             <Table>
//                 <TableHead>
//                     <TableRow>
//                         <TableCell>Name</TableCell>
//                         <TableCell>Email</TableCell>
//                         <TableCell>Phone</TableCell>
//                         <TableCell>Role</TableCell>
//                         <TableCell>status</TableCell>
//                         <TableCell>Created At</TableCell>
//                     </TableRow>
//                 </TableHead>
//                 <TableBody>
//                     {data?.map((user) => (
//                         <TableRow onClick={()=>handleNavigate(user?._id)} key={user?.userId?._id}>
//                             <TableCell>
//                                 {[user?.userId?.firstName, user?.userId?.lastName, user?.userId?.displayName]
//                                     ?.filter(Boolean)
//                                     .join(' ')}
//                             </TableCell>
//                             <TableCell>{user?.email || user?.userId?.email}</TableCell>
//                             <TableCell>{user?.mobile || user?.userId?.phone}</TableCell>
//                             <TableCell>{user?.userId?.role}</TableCell>
//                             <TableCell>{user?.status}</TableCell>
//                             <TableCell>
//                                 {new Date(user?.userId?.createdAt).toLocaleDateString()}
//                             </TableCell>
//                         </TableRow>
//                     ))}
//                 </TableBody>
//             </Table>
//         </TableContainer>
//     );
// };
// export default AllPartner;
import axios from "axios";
import React, { useEffect, useState } from "react";
import endpoints from "../../../endpoint";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchPartner } from "../../../redux/slices/partnerSlice";
import Loader from "../../../comman/Loader";

const AllPartner = () => {
  const navigate = useNavigate();
  const partner = useSelector((state) => state?.partner);
  const loading = partner?.loading;
  const dispatch = useDispatch();

  const data = partner?.partner;
  console.log(data);
  useEffect(() => {
    if (data?.length > 0) {
      return;
    }
    dispatch(fetchPartner());
  }, []);

  const handleNavigate = (partnerId) => {
    navigate("/admin-dashboard/partner/info/" + partnerId);
  };

  if (!data && loading) {
    <Loader />;
  }

  const approvedPartners = data?.filter((user) => user?.status === "approved");

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Phone</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Created At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {approvedPartners?.map((user) => (
            <TableRow
              onClick={() => handleNavigate(user?.userId?._id)}
              className="cursor-pointer"
              key={user?.userId?._id}
            >
              <TableCell>
                {[
                  user?.userId?.firstName,
                  user?.userId?.lastName,
                  user?.userId?.displayName,
                ]
                  ?.filter(Boolean)
                  .join(" ")}
              </TableCell>
              <TableCell>{user?.email || user?.userId?.email}</TableCell>
              <TableCell>{user?.mobile || user?.userId?.phone}</TableCell>
              <TableCell>{user?.userId?.role}</TableCell>
              <TableCell>{user?.status}</TableCell>
              <TableCell>
                {new Date(user?.userId?.createdAt).toLocaleDateString()}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AllPartner;
